"use client";

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["message", "size", "colorVariant", "className"];
import * as React from "react";
import styled from "styled-components";
import { spacing, textStyle } from "../../dimensions";
import { Spinner } from "../shared/Spinner";
var LoadingSpinner = function LoadingSpinner(_ref) {
  var message = _ref.message,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "small" : _ref$size,
    _ref$colorVariant = _ref.colorVariant,
    colorVariant = _ref$colorVariant === void 0 ? "primary" : _ref$colorVariant,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Container, _extends({
    className: className
  }, rest), /*#__PURE__*/React.createElement(Spinner, {
    size: size,
    colorVariant: colorVariant
  }), message && /*#__PURE__*/React.createElement(Message, {
    $colorVariant: colorVariant
  }, message));
};
export default LoadingSpinner;
var Container = styled.div.withConfig({
  displayName: "LoadingSpinner__Container",
  componentId: "sc-1aovhdo-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
var Message = styled.p.withConfig({
  displayName: "LoadingSpinner__Message",
  componentId: "sc-1aovhdo-1"
})(["", ";margin:", " 0 0;color:", ";"], textStyle.boising, spacing.auditorium, function (props) {
  return props.$colorVariant === "inverse" ? props.theme.text.inverse : props.theme.text.primary;
});